import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FormComponent from './pages/Form';
import FormView from './pages/FormView';
import AnalyticPage from './pages/AnalyticPage';
import InitiativeDetail from './pages/InitiativeDetail'; 
import Login from './pages/Login';
import Register from './pages/Register';
import LinkPage from './pages/LinkPage';
import MainPage from './pages/MainPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RegisterPrivacyPolicy from './pages/RegisterPrivacy';

function App() {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          
          <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/main-user" element={<MainPage />} />
            <Route path="/manage-form" element={<FormComponent />} />
            <Route path="/link-page" element={<LinkPage />} />

            <Route path="/form/:id" element={<FormView />} />
            <Route path="/analytics/:formId" element={<AnalyticPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/register-privacy-policy" element={<RegisterPrivacyPolicy />} />
            
            <Route path="/initiative-detail/:initiativeId" element={<InitiativeDetail />} /> 
            </Routes>
        </header>
      </div>
    </Router>
  );
}

export default App;